/**
 *
 */
export function createAvaState() {
    return {
        contexts: [],
    };
}
